/* eslint-disable react-hooks/exhaustive-deps */
import { Typography, withStyles, withTheme } from '@material-ui/core';
import { FilteringState, IntegratedFiltering } from '@devexpress/dx-react-grid';
import { Grid, Table, TableFilterRow, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { IntegratedSorting, SortingState } from '@devexpress/dx-react-grid';
import { compose } from 'recompose';
import React, { PureComponent } from 'react';
import Spinner from 'modules/common/spinner.component';
import classNames from 'classnames';

const styles = theme => {
  const intakeRecordBorder = `1px solid ${theme.palette.grey[500]}`;
  return {
    table: { borderSpacing: theme.spacing(0, 2) },
    tableHead: { height: 32 },
    cell: {
      borderTop: intakeRecordBorder,
      borderBottom: intakeRecordBorder,
      borderLeft: 0,
      borderRight: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderLeft: intakeRecordBorder
      },
      '&:last-child': {
        borderTopRightRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        borderRight: intakeRecordBorder
      }
    },
    row: { backgroundColor: theme.palette.common.white },
    noDataCell: { paddingBottom: theme.spacing(12), paddingTop: theme.spacing(12), textAlign: 'center' }
  };
};

const FILTER_DISABLED_COLUMNS = ['organization', 'actions'];

const getRootId = s => s.parentEmailTemplateId ?? s.templateId;

const getNewestInGroup = items => {
  if (!items || !Array.isArray(items)) return [];
  return items.reduce((best, cur) => {
    const bestV = best?.versionNumber ?? 1;
    const curV = cur?.versionNumber ?? 1;

    if (curV > bestV) return cur;
    if (curV < bestV) return best;

    return (cur?.templateId ?? 0) > (best?.templateId ?? 0) ? cur : best;
  }, null);
};

export const groupEmailTemplateSummaries = summaries => {
  const map = new Map();

  (summaries ?? []).forEach(s => {
    const rootId = getRootId(s);
    const group = map.get(rootId) ?? { rootId, versions: [] };
    group.versions.push(s);
    map.set(rootId, group);
  });

  return Array.from(map.values()).map(g => {
    const latest = getNewestInGroup(g.versions);

    return {
      rootId: g.rootId,
      latestTemplateId: latest.templateId,
      templateName: latest.templateName,
      serviceId: latest.serviceId,
      regardingId: latest.regardingId,
      templateUserTypeId: latest.templateUserTypeId,
      isSingleRequest: latest.isSingleRequest,
      isServiceGeneralTemplate: latest.isServiceGeneralTemplate,
      isApiRequest: latest.isApiRequest,
      versionStatusId: latest.versionStatusId,
      latestVersionNumber: latest.versionNumber ?? 1,
      versionCount: g.versions.length,

      versions: g.versions.slice().sort((a, b) => (b.versionNumber ?? 1) - (a.versionNumber ?? 1))
    };
  });
};

class AdminEmailTemplateGrid extends PureComponent {
  static defaultProps = { isLoading: false };

  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { name: 'rootId', title: 'Root Id', getCellValue: r => r.rootId },
        { name: 'templateName', title: 'Name', getCellValue: r => r.templateName },
        { name: 'service', title: 'Service', getCellValue: r => this.props.enumerations.authCommentService ? this.props.enumerations.authCommentService.find(s => s.id === r.serviceId)?.title : r.serviceId },
        { name: 'regarding', title: 'Regarding', getCellValue: r => this.props.enumerations.authCommentRegarding ? this.props.enumerations.authCommentRegarding.find(s => s.id === r.regardingId)?.title : r.regardingId },
        { name: 'versionStatusId', title: 'Version Status', getCellValue: r => this.props.enumerations.versionStatuses ? this.props.enumerations.versionStatuses.find(s => s.id === r.versionStatusId)?.title : r.versionStatusId },
        { name: 'latestVersionNumber', title: 'Latest Ver', getCellValue: r => r.latestVersionNumber },
        { name: 'versionCount', title: '# Versions', getCellValue: r => r.versionCount },
        { name: 'isApiRequest', title: 'Template Type', getCellValue: r => (r.isApiRequest ? 'API' : 'Email') }
      ],
      filters: [],
      sorting: [{ columnName: 'templateId', direction: 'desc' }],
      integratedFilteringColumnExtensions: [],
      tableColumnExtensions: [
        { columnName: 'rootId', width: 100 },
        { columnName: 'templateName', width: 250 },
        { columnName: 'service', width: 150 },
        { columnName: 'regarding', width: 150 },
        { columnName: 'versionStatusId', width: 125 },
        { columnName: 'latestVersionNumber', width: 100 },
        { columnName: 'versionCount', width: 100 }
      ]
    };
    this.changeSorting = sorting => this.setState({ sorting });
  }

  changeFilters = filters => this.setState({ filters });

  filterCell = props =>
    props.column.title && !FILTER_DISABLED_COLUMNS.includes(props.column.name) ? <TableFilterRow.Cell {...props} /> : null;

  headerCell = props => (props.column.title ? <TableHeaderRow.Cell {...props} /> : null);

  headerRowComponent = props => <TableHeaderRow.Row className={this.props.classes.tableHead} {...props} />;

  rowComponent = props => <Table.Row className={this.props.classes.row} {...props} />;

  cellComponent = props => {
    const templateId = props.row.latestTemplateId;
    const className = classNames(this.props.classes.cell, 'handles-click');
    return <Table.Cell onClick={() => this.props.history.push(`/templates/${templateId}`)} className={className} {...props} />;
  };

  // getDeleteCellValue = record => {
  //   return (
  //     <div>
  //       <Button
  //         variant="contained"
  //         size="small"
  //         sx={{
  //                 backgroundColor: '#868686',
  //                 color: '#ffffff',
  //                 '&:hover': { backgroundColor: '#6d6d6d' }
  //         }}
  //         onClick={event => {
  //           event.stopPropagation();
  //           this.handleDelete(record);
  //         }}
  //       >
  //         Hide
  //       </Button>
  //     </div>
  //   );
  // };

  handleDelete = row => {
    const confirmed = window.confirm('Are you sure you want to hide this template from the list?');
    if (confirmed) {
      this.props.hideTemplate(row.latestTemplateId);
    }
  };

  tableComponent = props => <Table.Table className={this.props.classes.table} {...props} />;

  noDataCellComponent = props => {
    const content = this.props.isLoading ? <Spinner logo /> : 'No Records were returned.  Check the filters above.';
    const { getMessage, ...rest } = props;
    return (
      <Table.Cell {...rest} className={this.props.classes.noDataCell}>
        <Typography>{content}</Typography>
      </Table.Cell>
    );
  };

  formatTemplates = (templates, enumerations) => {
    const authCommentServiceTypes =
      enumerations && enumerations.authCommentService && enumerations.authCommentService.length > 0
        ? enumerations.authCommentService.filter(s => s.isActive === true)
        : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    const authCommentRegardingTypes =
      enumerations && enumerations.authCommentRegarding && enumerations.authCommentRegarding.length > 0
        ? enumerations.authCommentRegarding.filter(s => s.isActive === true)
        : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    return templates.map(t => {
      const service = authCommentServiceTypes.find(s => s.id === t.serviceId);
      const regarding = authCommentRegardingTypes.find(r => r.id === t.regardingId);
      return {
        ...t,
        service: service ? service.title : 'N/a',
        regarding: regarding ? regarding.title : 'N/a'
      };
    });
  };

  render() {
    const { enumerations, emailTemplates } = this.props;
    const { columns, filters, tableColumnExtensions, integratedFilteringColumnExtensions, sorting } = this.state;
    let templatesFormated = this.formatTemplates(emailTemplates, enumerations);
    const groupedRows = groupEmailTemplateSummaries(templatesFormated);

    return (
      <Grid rows={groupedRows} columns={columns}>
        <SortingState sorting={sorting} onSortingChange={this.changeSorting} />
        <FilteringState filters={filters} onFiltersChange={this.changeFilters} />
        <IntegratedFiltering columnExtensions={integratedFilteringColumnExtensions} />
        <IntegratedSorting />
        <Table
          columnExtensions={tableColumnExtensions}
          rowComponent={this.rowComponent}
          tableComponent={this.tableComponent}
          cellComponent={this.cellComponent}
          noDataCellComponent={this.noDataCellComponent}
        />
        <TableHeaderRow rowComponent={this.headerRowComponent} cellComponent={this.headerCell} showSortingControls />
        <TableFilterRow cellComponent={this.filterCell} />
      </Grid>
    );
  }
}

export default compose(withStyles(styles), withTheme)(AdminEmailTemplateGrid);
